import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch } from "react-redux";
import { clearNotification } from "../redux/commonSlice";
import { useAppSelector } from "../store/hooks";

export default function Notification(props: any) {
    const dispatch = useDispatch();

    const notification = useAppSelector((state) => state.common.notification);

    const handleClose = () => {
        dispatch(clearNotification());
    };

    return (
        <Snackbar
            open={notification.isOpen}
            autoHideDuration={2000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={handleClose}
        >
            <Alert
                elevation={6}
                variant="filled"
                onClose={handleClose}
                severity={notification.type}
            >
                {notification.message}
            </Alert>
        </Snackbar>
    );
}
